var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5519 17.8276C9.90809 17.4996 9.19144 17.3296 8.46265 17.3296C2.77807 17.7304 2.77807 26.0022 8.46265 26.4031H21.9332C23.5729 26.4152 25.152 25.8079 26.3545 24.7025C30.3507 21.2165 28.2129 14.2079 22.9535 13.5399C21.0586 2.15858 4.62435 6.48274 8.52338 17.3296",
    fill: "url(#paint0_linear_1197_10982)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6569 28.8039C25.6569 28.8039 30.2669 26.4989 30.2669 23.0413V19.0076L25.6569 17.2788L21.0469 19.0076V23.0413C21.0469 26.4989 25.6569 28.8039 25.6569 28.8039Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6569 28.8039C25.6569 28.8039 30.2669 26.4989 30.2669 23.0413V19.0076L25.6569 17.2788L21.0469 19.0076V23.0413C21.0469 26.4989 25.6569 28.8039 25.6569 28.8039Z",
    fill: "url(#paint1_linear_1197_10982)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9082 22.5331L24.942 24.567L28.3318 21.1772",
    stroke: "white",
    strokeWidth: 1.01692,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_10982",
    x1: 15.2486,
    y1: 6.82813,
    x2: 13.5984,
    y2: 31.0523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FF8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1197_10982",
    x1: 25.6569,
    y1: 17.2788,
    x2: 25.6569,
    y2: 28.8039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon8);
export default __webpack_public_path__ + "static/media/drive_card_icon8.dd1cb35b316e99c3ec622ee43d1f7a76.svg";
export { ForwardRef as ReactComponent };